import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  assignAdmin,
  assignFillingPerson,
  assignMachineAdmin,
  removeAdmin,
  removeFillingPerson,
  removeMachineAdmin,
} from "data/server_apis/vendingServices";

export const machineAssignmentState = {
  adminAssignMentLoading: {},
  adminAssignMentError: {},
  adminAssignMentSuccess: {},
  adminAssignMentErrorMessage: {},

  adminRemoveLoading: {},
  adminRemoveError: {},
  adminRemoveSuccess: {},
  adminRemoveErrorMessage: {},
  
  machineAdminAssignMentLoading: {},
  machineAdminAssignMentError: {},
  machineAdminAssignMentSuccess: {},
  machineAdminAssignMentErrorMessage: {},

  machineAdminRemoveLoading: {},
  machineAdminRemoveError: {},
  machineAdminRemoveSuccess: {},
  machineAdminRemoveErrorMessage: {},


  fillingPersonAssignmentLoading: {},
  fillingPersonAssignmentError: {},
  fillingPersonAssignmentSuccess: {},
  fillingPersonAssignmentErrorMessage: {},

  fillingPersonRemoveLoading: {},
  fillingPersonRemoveError: {},
  fillingPersonRemoveSuccess: {},
  fillingPersonRemoveErrorMessage: {},
};


export const assignAdminThunk = createAsyncThunk(
  "vending/assignAdmin",
  async (data, { rejectWithValue }) => {
    console.log(data)
    try {
      return (
        await assignAdmin({
          admin: data.admin.id,
          machine: data.machine,
        })
      ).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const removeAdminThunk = createAsyncThunk(
  "vending/removeAdmin",
  async (data, { rejectWithValue }) => {
    try {
      return (await removeAdmin(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const assignMachineAdminThunk = createAsyncThunk(
  "vending/assignMachineAdmin",
  async (data, { rejectWithValue }) => {
    console.log(data)
    try {
      return (
        await assignMachineAdmin({
          machine_admin: data.machine_admin.id,
          machine: data.machine,
        })
      ).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const removeMachineAdminThunk = createAsyncThunk(
  "vending/removeMachineAdmin",
  async (data, { rejectWithValue }) => {
    try {
      return (await removeMachineAdmin(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const assignFillingPersonThunk = createAsyncThunk(
  "vending/assignFillingPerson",
  async (data, { rejectWithValue }) => {
    console.log("data",data)
    try {
      return (
        await assignFillingPerson({
          filling_person: data.filling_person.id,
          machine: data.machine,
        })
      ).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const removeFillingPersonThunk = createAsyncThunk(
  "vending/removeFillingPerson",
  async (data, { rejectWithValue }) => {
    try {
      return (await removeFillingPerson(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const machineAssignmentBuilder = (builder) => {
  builder
    .addCase(assignAdminThunk.pending, (state, action) => {
      state.adminAssignMentLoading[
        action.meta.arg.admin.id
      ] = true;
      state.adminAssignMentError = {};
      state.adminAssignMentSuccess = {};
      state.adminAssignMentErrorMessage = {};
    })
    .addCase(assignAdminThunk.rejected, (state, action) => {
      state.adminAssignMentLoading = {};
      state.adminAssignMentError[
        action.meta.arg.admin.id
      ] = true;
      state.adminAssignMentSuccess = {};
      state.adminAssignMentErrorMessage[
        action.meta.arg.admin.id
      ] = action.payload?.message;
    })
    .addCase(assignAdminThunk.fulfilled, (state, action) => {
      state.adminAssignMentLoading = {};
      state.adminAssignMentError = {};
      state.adminAssignMentSuccess[
        action.meta.arg.admin.id
      ] = true;
      state.adminAssignMentErrorMessage = {};
      const machine = state.machines.find(
        (item) => item.id === action.meta.arg.machine
      );
      console.log("Machine", machine);
      if (machine) {
        machine.admins.push(action.meta.arg.admin);
      }
    });

  builder
    .addCase(removeAdminThunk.pending, (state, action) => {
      state.adminRemoveLoading[action.meta.arg.admin] = true;
      state.adminRemoveError = {};
      state.adminRemoveSuccess = {};
      state.adminRemoveErrorMessage = {};
    })
    .addCase(removeAdminThunk.rejected, (state, action) => {
      state.adminRemoveLoading = {};
      state.adminRemoveError[action.meta.arg.admin] = true;
      state.adminRemoveSuccess = {};
      state.adminRemoveErrorMessage[action.meta.arg.admin] =
        action.payload?.message;
    })
    .addCase(removeAdminThunk.fulfilled, (state, action) => {
      state.adminRemoveError = {};
      state.adminRemoveSuccess[action.meta.arg.admin] = true;
      state.adminRemoveErrorMessage = {};
      const machine = state.machines.find(
        (item) => item.id === action.meta.arg.machine
      );
      if (machine) {
        machine.admins = machine.admins.filter(
          (admin) => admin.id !== action.meta.arg.admin
        );
      }
      state.adminRemoveLoading = {};
    });
  builder
    .addCase(assignMachineAdminThunk.pending, (state, action) => {
      state.machineAdminAssignMentLoading[
        action.meta.arg.machine_admin.id
      ] = true;
      state.machineAdminAssignMentError = {};
      state.machineAdminAssignMentSuccess = {};
      state.machineAdminAssignMentErrorMessage = {};
    })
    .addCase(assignMachineAdminThunk.rejected, (state, action) => {
      state.machineAdminAssignMentLoading = {};
      state.machineAdminAssignMentError[
        action.meta.arg.machine_admin.id
      ] = true;
      state.machineAdminAssignMentSuccess = {};
      state.machineAdminAssignMentErrorMessage[
        action.meta.arg.machine_admin.id
      ] = action.payload?.message;
    })
    .addCase(assignMachineAdminThunk.fulfilled, (state, action) => {
      state.machineAdminAssignMentLoading = {};
      state.machineAdminAssignMentError = {};
      state.machineAdminAssignMentSuccess[
        action.meta.arg.machine_admin.id
      ] = true;
      state.machineAdminAssignMentErrorMessage = {};
      const machine = state.machines.find(
        (item) => item.id === action.meta.arg.machine
      );
      console.log("Machine", machine);
      if (machine) {
        machine.machine_admins.push(action.meta.arg.machine_admin);
      }
    });

  builder
    .addCase(removeMachineAdminThunk.pending, (state, action) => {
      state.machineAdminRemoveLoading[action.meta.arg.machine_admin] = true;
      state.machineAdminRemoveError = {};
      state.machineAdminRemoveSuccess = {};
      state.machineAdminRemoveErrorMessage = {};
    })
    .addCase(removeMachineAdminThunk.rejected, (state, action) => {
      state.machineAdminRemoveLoading = {};
      state.machineAdminRemoveError[action.meta.arg.machine_admin] = true;
      state.machineAdminRemoveSuccess = {};
      state.machineAdminRemoveErrorMessage[action.meta.arg.machine_admin] =
        action.payload?.message;
    })
    .addCase(removeMachineAdminThunk.fulfilled, (state, action) => {
      state.machineAdminRemoveError = {};
      state.machineAdminRemoveSuccess[action.meta.arg.machine_admin] = true;
      state.machineAdminRemoveErrorMessage = {};
      const machine = state.machines.find(
        (item) => item.id === action.meta.arg.machine
      );
      if (machine) {
        machine.machine_admins = machine.machine_admins.filter(
          (admin) => admin.id !== action.meta.arg.machine_admin.id
        );
      }
      state.machineAdminRemoveLoading = {};
    });


    builder
    .addCase(assignFillingPersonThunk.pending, (state, action) => {
      state.fillingPersonAssignmentLoading[
        action.meta.arg.filling_person.id
      ] = true;
      state.fillingPersonAssignmentError = {};
      state.fillingPersonAssignmentSuccess = {};
      state.fillingPersonAssignmentErrorMessage = {};
    })
    .addCase(assignFillingPersonThunk.rejected, (state, action) => {
      console.log("Error",action.payload)
      state.fillingPersonAssignmentLoading = {};
      state.fillingPersonAssignmentError[
        action.meta.arg.filling_person.id
      ] = true;
      state.fillingPersonAssignmentSuccess = {};
      state.fillingPersonAssignmentErrorMessage[
        action.meta.arg.filling_person.id
      ] = action.payload?.message;
    })
    .addCase(assignFillingPersonThunk.fulfilled, (state, action) => {
      state.fillingPersonAssignmentLoading = {};
      state.fillingPersonAssignmentError = {};
      state.fillingPersonAssignmentSuccess[
        action.meta.arg.filling_person.id
      ] = true;
      state.fillingPersonAssignmentErrorMessage = {};
      const machine = state.machines.find(
        (item) => item.id === action.meta.arg.machine
      );
      console.log("Machine", machine);
      if (machine) {
        machine.filling_persons.push(action.meta.arg.filling_person);
      }
    });

  builder
    .addCase(removeFillingPersonThunk.pending, (state, action) => {
      state.fillingPersonRemoveLoading[action.meta.arg.filling_person] = true;
      state.fillingPersonRemoveError = {};
      state.fillingPersonRemoveSuccess = {};
      state.fillingPersonRemoveErrorMessage = {};
    })
    .addCase(removeFillingPersonThunk.rejected, (state, action) => {
      state.fillingPersonRemoveLoading = {};
      state.fillingPersonRemoveError[action.meta.arg.filling_person] = true;
      state.fillingPersonRemoveSuccess = {};
      state.fillingPersonRemoveErrorMessage[action.meta.arg.filling_person] =
        action.payload?.message;
    })
    .addCase(removeFillingPersonThunk.fulfilled, (state, action) => {
      state.fillingPersonRemoveError = {};
      state.fillingPersonRemoveSuccess[action.meta.arg.filling_person] = true;
      state.fillingPersonRemoveErrorMessage = {};
      const machine = state.machines.find(
        (item) => item.id === action.meta.arg.machine
      );
      if (machine) {
        machine.filling_persons = machine.filling_persons.filter(
          (filling_person) => filling_person.id !== action.meta.arg.filling_person
        );
      }
      state.fillingPersonRemoveLoading = {};
    });
};
